const $ = require('jquery');
import Swiper from 'swiper/bundle';
const headerEl = $(".header");
const hamburgerEl = $(".js-header__hamburger");
const bodyEl = $("body");
let previousScroll = 0;
function header() {

  if (headerEl.length > 0) {
    $(window).on("scroll", function() {
      onScroll();
    })
    onScroll();
  }

  hamburgerEl.on("click", function() {
    headerEl.toggleClass("header--open");
    bodyEl.toggleClass("has-nav");
  });

  const hamburger = document.querySelector('.hamburger');
  const menu = document.querySelector('.header__right') as HTMLElement;
  if(hamburger) {
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('is-active');
      // menu.classList.toggle('show-active');
      if (hamburger.classList.contains('is-active')) {
        menu.style.display = "flex";
      } else {
        menu.style.display = "none";
      }
    })
  }






  
  const slides_count = document.getElementsByClassName("hero-slider__image");
  const slides_count_dup = document.getElementsByClassName("hero-slider__image swiper-slide-duplicate");
  const swiper = new Swiper('.hero-slider__slider', {
    // Optional parameters
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
    spaceBetween: 22,
    breakpoints: {
      992: {
        longSwipes: false,
        shortSwipes: false,
        allowTouchMove: false,
        slidesPerView: 1.7,
        slidesPerGroup: 1.7,
      }
    },
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // runCallbacksOnInit: true,
    // === new change
    on: {
      slideChange: function(){
        const counter = document.querySelector('.numberSlides');
        counter.innerHTML = Math.abs(this.realIndex + 1 ) + '/' + (slides_count.length - slides_count_dup.length);
      }
    }
  });
}

function onScroll() {

  let currentScroll = $(window).scrollTop();


  if (currentScroll > 200){
    headerEl.addClass('header--scroll');
    if (currentScroll > previousScroll) {
      headerEl.removeClass("header--scroll-up");
      headerEl.addClass("header--scroll-down");
    } else {
      headerEl.removeClass("header--scroll-down");
      headerEl.addClass("header--scroll-up");
    }
  } else {
    headerEl.removeClass('header--scroll')
    headerEl.removeClass("header--scroll-up");
    headerEl.removeClass("header--scroll-down");
  }
  previousScroll = currentScroll;


}



export default header;

